import React, { useEffect, useState } from "react";
import classes from "../../styles/pujaMainCard.module.css";
import theme from "src/globalModule/styles/theme";
import { Typography } from "@mui/material";
import Image from "next/legacy/image";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { prettyDateDay } from "@utils/metrics/timeFunction";
import { useRouter } from "next/router";
function PujaDetailsCard({
  subEventDetails
}) {
  const router = useRouter();
  const [images, setImages] = useState([]);
  const [eventName, setEventName] = useState("");
  const [name, setName] = useState("");
  const [pujaDate, setPujaDate] = useState("");
  useEffect(() => {
    if (subEventDetails) {
      setImages(subEventDetails?.images || []);
      setEventName(subEventDetails?.eventName);
      setName(subEventDetails?.name);
      setPujaDate(subEventDetails?.start);
    }
  }, [subEventDetails]);
  return <div className={classes.containerRHS} data-sentry-component="PujaDetailsCard" data-sentry-source-file="pujaDetailsCard.jsx">
      <div className={classes.pujaDetails}>
        {images.length > 0 && <Image src={images[0] || ""} alt="Sub Event Image" width={80} height={80} objectFit="cover" className={classes.pujaImageItem} />}

        <div className={classes.pujaDetailsCard}>
          <Typography sx={{
          fontSize: "16px",
          fontWeight: "600"
        }} className={classes.ellipsisHeader} data-sentry-element="Typography" data-sentry-source-file="pujaDetailsCard.jsx">
            {eventName}
          </Typography>
          <Typography sx={{
          fontSize: "15px"
        }} className={classes.ellipsisText} data-sentry-element="Typography" data-sentry-source-file="pujaDetailsCard.jsx">
            {name}
          </Typography>
          <div className={classes.dateContainer}>
            <CalendarMonthIcon sx={{
            fontSize: "14px"
          }} data-sentry-element="CalendarMonthIcon" data-sentry-source-file="pujaDetailsCard.jsx" />
            <Typography sx={{
            fontSize: "14px",
            color: theme.palette.text.primaryHead
          }} data-sentry-element="Typography" data-sentry-source-file="pujaDetailsCard.jsx">
              {prettyDateDay(new Date(parseInt(pujaDate)), router.locale)}
            </Typography>
          </div>
        </div>
      </div>
    </div>;
}
export default PujaDetailsCard;